/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Facet { 
    /**
     * Display name of the facet
     */
    facetDisplayName?: string;
    /**
     * count of the facet
     */
    facetCount?: number;
    /**
     * Type of the facet
     */
    facetType?: string;
    /**
     * unique identifier of the facet
     */
    facetId?: string;
    /**
     * list of facets
     */
    facets?: Array<Facet>;
}
